import { TimeAutoRefresh } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const timeAutoRefreshDictionary = createSimpleDictionary([
    { id: TimeAutoRefresh.FiveSeconds, name: 'dictionaries.timeAutoRefresh.5s' },
    { id: TimeAutoRefresh.FifteenSeconds, name: 'dictionaries.timeAutoRefresh.15s' },
    { id: TimeAutoRefresh.ThirtySeconds, name: 'dictionaries.timeAutoRefresh.30s' },
    { id: TimeAutoRefresh.OneMinute, name: 'dictionaries.timeAutoRefresh.1min' },
    { id: TimeAutoRefresh.FiveMinutes, name: 'dictionaries.timeAutoRefresh.5min' },
    { id: TimeAutoRefresh.Off, name: 'dictionaries.timeAutoRefresh.off' },
]);
